import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { statusPillClass } from '../domain/schema';

/**
 * StatusPill — outlined status badge using the app-global title-tag-badge pill classes.
 * Uses the design-system outlined pill: teal for steady states, amber for problem states.
 */
function StatusPill({ status }) {
  return (
    <Badge variant="secondary" className={statusPillClass(status)}>
      {status || 'unknown'}
    </Badge>
  );
}

export default StatusPill;
